export default __webpack_public_path__ + "static/media/gold-wheel-two.9a29c0a3.svg";